<template>
  <InstitucionalPageTemplate :loading="loading" :item="item" />
</template>

<script>
import InstitucionalPageTemplate from "../components/templates/InstitucionalPageTemplate.vue";

const _config = {
  mod: "about",
};

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    InstitucionalPageTemplate,
  },
};
</script>
